import React from 'react';
import styles from './styles';
// General/Context
import { Loader, removeStagingMedia, WindowDisplay} from '@xpertdox_js/xdcomponents';
// hooks
import getWindows from './Hooks/windowSettings';
import unStageMedia from './Hooks/unStageMedia';
import {fetchTrial, updateTrial} from './Hooks/fetchers';
import axiosConfig from '../../config/axios.config';
import { trackError } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext';
// components

const TrialOverview = props => {
  // -- var deps
  const {id, instance, user, overviewData, setOverviewData, diffState, setDiff, diffRef, windowDisplayDims, filters, allNcts} = props.deps;
  const {diff} = diffRef.current;
  // -- downstream ref for storing values from child components that lose scope downstream
  const childStore = React.useRef({});
  const setChildStore = (property, value) => childStore.current[property] = value;
  // -- trackers store
  const fetchedList = React.useRef({trials: !!overviewData})
  const lastID = React.useRef(id);
  const setHasFetched = (property, value) => fetchedList.current[property] = value;
  const hasFetched = fetchedList.current;
  const { userAction } = React.useContext(UserContext);

  // -- cleanup
  const flyerCleanup = () => {
    if (diffState && diffState.flyer) removeStagingMedia([diffState.flyer])
    else if (diff.flyer) removeStagingMedia([diff.flyer]);
  }
  const piCleanup = () => {
    if (childStore.addedPIs && childStore.addedPIs.length) {
      removeStagingMedia(childStore.addedPIs.map(piInfo => piInfo.image ? piInfo.image._id : false).filter(val => val), axiosConfig);
      delete childStore.addedPIs;}
  }
  const handleCleanup = () => {flyerCleanup();piCleanup()}
  // clean staging assets from server on unmount
  React.useEffect(() => () => handleCleanup(), []);

  // -- Request Handlers
  if (lastID.current !== id) {
    setHasFetched('trials', false);
    lastID.current = id;
  }
  // fetch trial
  if (!hasFetched.trials) {
    setHasFetched('trials', true);
    fetchTrial(id, instance, user.email).then(data => setOverviewData(data)).catch(err => {
      trackError({ error: err, history: props.history })
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    })
  }
  // save trial
  const handleSave = async () => {
    try {
      // console.log(diffState, "DIFF STATE");
      if (diffState && diffState.studyFlyer) {
        let flyer = await unStageMedia([diffState.studyFlyer])
        diffState.studyFlyer = flyer[0]._id
      }
      if (diffState && diffState.PIs) {
        let finalPis = [];
        let Pis = await unStageMedia(
          diffState.PIs.map((piInfo, i) => piInfo.image && piInfo.image._id ? {
              _id: piInfo.image._id,
              name: piInfo.name,
              link: piInfo.link
            } : i
          ).filter(val => {
            if(val._id) return val
            else finalPis.push(diffState.PIs[val])
          }));
          diffState.PIs = [...finalPis, ...Pis]
      }
      if (childStore.addedPIs && childStore.addedPIs.length) {
        await unStageMedia(childStore.addedPIs.map(piInfo => piInfo.image ? piInfo.image._id : false).filter(val => val));
      }
      // const currentInvestigators = overviewData.trialData.investigators ? overviewData.trialData.investigators : [];
      await updateTrial(id, instance, user.email, user.id, overviewData, diffState)
      setHasFetched('trials', false);
      props.deps.removeFromCache(id);
      if (childStore.addedPIs) delete childStore.addedPIs;
      setDiff({});
      props.deps.refreshCache('allTrials');
    } catch(err) {
      console.error(err, "ERRR")
      if (err && err.response && err.response.status === 403) {
        userAction({type: 'logout'})
      }
    }
  }

  const allNctsToPass = props.location.state && props.location.state.allNcts ? props.location.state.allNcts :  allNcts;

  // -- get windows for window display
  const trialWindows = getWindows(overviewData
    ? {handleSave, diffRef, setDiff, user, instance, filters, id, childStore, setChildStore, overviewData, allNctsToPass, history: props.history, match: props.match}
    : null
  );

  return(overviewData
    ? <WindowDisplay
      key={id}
      styles={{
        container: {...windowDisplayDims, maxHeight: windowDisplayDims.height},
      }}
      settings={{
        windows: 2,
        initial: props.initialWindows,
        windowSettings: {...trialWindows},
        initialUpdate: props.setInitialWindows
      }}
    />
  : <Loader
      styles={styles.loaderStyles}
      width='132px'
      height='132px'
      noBg
    />
  )
}

export default TrialOverview;
